(function () {
	'use strict';

	var GIFT_PROPERTY = '_igGWP';
	var STORAGE_KEY = 'gwp-decline';

	var CART_ADD_RE = /\/cart\/add(\.js|\.json)?$/;
	var CART_CHANGE_RE = /\/cart\/change(\.js|\.json)?$/;
	var CART_UPDATE_RE = /\/cart\/update(\.js|\.json)?$/;

	var decline = readDecline();
	var snapshot = null;

	var REFRESH_THROTTLE_MS = 500;
	var lastFetchAt = 0;

	function readDecline() {
		try {
			var raw = localStorage.getItem(STORAGE_KEY);
			if (!raw) return null;
			var parsed = JSON.parse(raw);
			if (!parsed || !Array.isArray(parsed.variantIds)) return null;
			return { variantIds: parsed.variantIds.map(String) };
		} catch (error) {
			return null;
		}
	}

	function writeDecline(next) {
		decline = next;
		try {
			if (next) localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
			else localStorage.removeItem(STORAGE_KEY);
		} catch (error) {
			return;
		}
	}

	function isGiftLine(item) {
		return !!(item && item.properties && item.properties[GIFT_PROPERTY] !== undefined);
	}

	function qualifyingVariantIds(cart) {
		var items = (cart && cart.items) || [];
		var ids = [];
		for (var i = 0; i < items.length; i++) {
			if (!isGiftLine(items[i])) ids.push(String(items[i].variant_id));
		}
		return ids;
	}

	function reconcile(cart) {
		if (!decline) return;
		var present = qualifyingVariantIds(cart);
		var intact = decline.variantIds.every(function (id) {
			return present.indexOf(id) !== -1;
		});
		if (!intact) writeDecline(null);
	}

	function cartUrl() {
		try {
			return Theme.routes.cart_url;
		} catch (error) {
			return ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart';
		}
	}

	function fetchCart(force) {
		var now = Date.now();
		if (!force && now - lastFetchAt < REFRESH_THROTTLE_MS) return Promise.resolve(snapshot);
		lastFetchAt = now;

		return originalFetch
			.call(window, cartUrl() + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
			.then(function (response) {
				if (!response.ok) throw new Error('gwp-decline: /cart.js returned ' + response.status);
				return response.json();
			})
			.then(function (cart) {
				snapshot = cart;
				reconcile(cart);
				return cart;
			})
			.catch(function () {
				return null;
			});
	}

	function pathOf(url) {
		try {
			return new URL(url, window.location.href).pathname;
		} catch (error) {
			return '';
		}
	}

	function parseBody(body) {
		try {
			if (typeof body === 'string') return JSON.parse(body);
		} catch (error) {
			return null;
		}
		return null;
	}

	function isThemeOriginated(parsed) {
		return !!parsed && parsed.sections !== undefined;
	}

	function zeroesALine(parsed) {
		if (Number(parsed.quantity) === 0 && (parsed.line !== undefined || parsed.id !== undefined)) return true;
		if (!parsed.updates || typeof parsed.updates !== 'object') return false;
		return Object.keys(parsed.updates).some(function (key) {
			return Number(parsed.updates[key]) === 0;
		});
	}

	function cartHasGift(cart) {
		return !!cart && Array.isArray(cart.items) && cart.items.some(isGiftLine);
	}

	function isGiftAdd(parsed) {
		var items = parsed && Array.isArray(parsed.items) ? parsed.items : parsed ? [parsed] : [];
		return items.some(function (item) {
			return !!(item && item.properties && item.properties[GIFT_PROPERTY] !== undefined);
		});
	}

	function blockedResponse() {
		return new Response(JSON.stringify({ items: [], description: 'gift declined by customer' }), {
			status: 409,
			statusText: 'Conflict',
			headers: { 'Content-Type': 'application/json' },
		});
	}

	var originalFetch = window.fetch;

	window.fetch = function (input, init) {
		var call = arguments;
		var self = this;
		var passThrough = function () {
			return originalFetch.apply(self, call);
		};

		try {
			var isRequest = typeof Request !== 'undefined' && input instanceof Request;
			var url = isRequest ? input.url : input;
			var method = (init && init.method) || (isRequest ? input.method : 'GET');
			if (!method || String(method).toUpperCase() !== 'POST') return passThrough();

			var path = pathOf(url);
			var parsed = parseBody(init && init.body);
			if (!parsed) return passThrough();

			if (CART_CHANGE_RE.test(path) || CART_UPDATE_RE.test(path)) {
				var couldDecline = isThemeOriginated(parsed) && zeroesALine(parsed) && cartHasGift(snapshot);
				var result = passThrough();
				result
					.then(function (response) {
						if (!response || !response.ok) return null;
						return response.clone().json();
					})
					.then(function (after) {
						if (!after || !Array.isArray(after.items)) return fetchCart();
						if (couldDecline && !cartHasGift(after) && after.items.length > 0) {
							writeDecline({ variantIds: qualifyingVariantIds(after) });
						}
						snapshot = after;
						lastFetchAt = Date.now();
						reconcile(after);
					})
					.catch(function () {
						return null;
					});
				return result;
			}

			if (CART_ADD_RE.test(path) && isGiftAdd(parsed)) {
				return fetchCart(true).then(function () {
					if (decline) return blockedResponse();
					var allowed = passThrough();
					allowed.then(function () {
						fetchCart(true);
					}, function () {});
					return allowed;
				});
			}

			if (CART_ADD_RE.test(path)) {
				var added = passThrough();
				added.then(function () {
					fetchCart(true);
				}, function () {});
				return added;
			}
		} catch (error) {
			return passThrough();
		}

		return passThrough();
	};

	document.addEventListener('cart:update', function () {
		fetchCart();
	});

	var seed = function () {
		fetchCart();
	};
	if (typeof requestIdleCallback === 'function') requestIdleCallback(seed, { timeout: 3000 });
	else setTimeout(seed, 1000);
})();
